<template>
  <div class="contact">
    <page-top v-bind="pageTop" />
    <main>
      <v-container>
        <v-heading level="h6">
          Preencha o formulário abaixo, ou se preferir, entre com contato pelo telefone <u>{{phones.tel}}</u> (de segunda a sexta, das 8h às 18h)
        </v-heading>
        <v-form :schema="schema" @success="sendForm($event)" :status="status" ref="contactForm"/>
      </v-container>
    </main>
    <locations-map />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Form from '@/components/uikit/form/Form.vue';
import PageTop from '@/components/layout/PageTop.vue';
import LocationsMap from '@/components/location/LocationsMap.vue';

const meta = [
  {
    vmid: 'og:title',
    name: 'og:title',
    template: 'Convênios',
  },
  {
    vmid: 'description',
    name: 'description',
    content: 'Ente em contato com a URC. Primeira e única clínica em SJC que possui a ressonância magnética de campo aberto de alta resolução.',
  },
  {
    vmid: 'og:description',
    name: 'og:description',
    content: 'Ente em contato com a URC. Primeira e única clínica em SJC que possui a ressonância magnética de campo aberto de alta resolução.',
  },
];

export default {
  name: 'Insurances',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-form': Form,
    'page-top': PageTop,
    'locations-map': LocationsMap,
  },
  metaInfo: {
    title: 'Convênios',
    meta,
  },
  computed: {
    ...mapState({
      status: state => state.contact.form.status,
      pageTop: state => state.contact.page.content,
      phones: state => state.globals.vars.phones,
    }),
  },
  data() {
    return {
      schema: [
        {
          label: 'Nome',
          type: 'text',
          name: 'full_name',
          id: 'fullName',
          placeholder: 'Digite seu nome completo',
          cols: 4,
          validations: {
            required: true,
          },
        },
        {
          label: 'Email',
          type: 'email',
          name: 'email',
          id: 'email',
          placeholder: 'Digite seu e-mail',
          cols: 4,
          validations: {
            email: true,
            required: true,
          },
        },
        {
          label: 'Assunto',
          type: 'select',
          name: 'subject',
          id: 'subject',
          placeholder: 'Selecione o assunto',
          cols: 4,
          validations: {
            required: true,
          },
          options: [
            { title: 'Duvidas', value: 'Dúvidas' },
            { title: 'Reclamacoes', value: 'Reclamações' },
            { title: 'Sugestoes', value: 'Sugestoes' },
            { title: 'Elogios', value: 'Elogios' },
          ],
        },
        {
          label: 'Mensagem',
          type: 'textarea',
          name: 'message',
          id: 'message',
          placeholder: 'Digite sua mensagem',
          validations: {
            required: true,
          },
        },
      ],
    };
  },
  methods: {
    async sendForm(data) {
      this.$store.commit('contact/form/setData', data);
      await this.$store.dispatch('contact/form/sendData')
        .then((resp) => {
          this.$store.dispatch('messages/add', {
            type: resp.errors ? 'error' : 'success',
            text: resp.message,
          });
          if (!resp.errors) {
            this.$refs.contactForm.reset();
          }
        });
    },
  },
  async created() {
    await this.$store.dispatch('contact/page/getContent');
  },
};
</script>

<style lang="scss" scoped>
$component: '.contact';
#{$component} {
  /deep/ .page-top__title {
    color: $color-a;
  }
  main {
    background-color: $bg-gray;
    padding: $section-gutter 0;
    .heading {
      max-width: 600px;
      margin: 0 auto $gutter-xxxl;
      text-align: center;
    }
    /deep/ .form {
      .form__footer {
        text-align: center;
        .btn {
          min-width: 240px;
        }
      }
    }
  }
}
</style>
